import React from "react";

export default function AdditionInfo({
  color = "#E11B22",
  width = "24",
  height = "24",
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3 20H14V22H3C2.20435 22 1.44129 21.6839 0.87868 21.1213C0.31607 20.5587 0 19.7956 0 19V3C0 2.20435 0.31607 1.44129 0.87868 0.87868C1.44129 0.31607 2.20435 0 3 0H14C14.1552 0 14.3084 0.0361451 14.4472 0.105573C14.5861 0.175001 14.7069 0.275804 14.8 0.4L17.8 4.4C17.9298 4.5731 18 4.78363 18 5V10H16V5.33L13.5 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V19C2 19.2652 2.10536 19.5196 2.29289 19.7071C2.48043 19.8946 2.73478 20 3 20ZM22 16H18V12H16V16H12V18H16V22H18V18H22V16ZM13 5H5V7H13V5ZM5 11H11V9H5V11Z"
        fill={color}
      />
    </svg>
  );
}
